import { Button } from "antd";
import React, { useEffect, useState } from "react";

import "./PackageListDrop.scss";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectAllPackageTypes } from "modules/client/package-types/store/slice";

const PackageListDrop = ({ id, packages, selectedPack, isAll }) => {
  const [packsByType, setPackByType] = useState([]);
  const packageTypeList = useSelector(selectAllPackageTypes);

  useEffect(() => {
    const rs = {};
    if (!packages.length || !packageTypeList.length) return;
    packages.forEach((pack) => {
      // Only process packages that are actually allocated to this dropoff
      const dropoffAllocation = pack?.dropoffs?.find((drop) => drop.id === id);
      if (!dropoffAllocation) return; // Skip if not allocated to this dropoff

      const packageType = packageTypeList.find((p) => p.id === pack.packageTypeId);
      rs[packageType?.name] = rs[packageType?.name] || [];
      rs[packageType?.name].push({
        ...pack,
        quantity: dropoffAllocation.quantity
      });
    });

    const rsPack = Object.keys(rs).map((key, i) => {
      const packArr = rs[key];

      return packArr.reduce((acc, curr) => {
        if (Object.keys(acc).includes(key)) {
          acc = {
            ...acc,
            [key]: {
              quantity: acc[key]?.quantity + curr?.quantity,
              name: key
            }
          };
        } else {
          acc[key] = {
            quantity: curr.quantity,
            name: key
          };
        }

        return acc;
      }, {});
    });

    setPackByType(rsPack);
  }, [id, packages, packageTypeList]);

  return (
    <div className="PackageListDrop">
      <h1>PACKAGE REVIEW</h1>
      {packsByType.length > 0 &&
        packsByType.map((rsP, rsPIndex) => {
          return (
            <div className="package-item" key={rsPIndex + 1}>
              <div className="bottom">
                {Object.keys(rsP).map((key, index) => {
                  const pack = rsP[key];
                  return (
                    <>
                      <div className="top">
                        <div className="content">
                          <b>{key} Package</b>
                        </div>
                      </div>
                      <p key={index + 1}>
                        {index + 1}. {pack.name} x {pack.quantity}
                      </p>
                    </>
                  );
                })}
              </div>
            </div>
          );
        })}
      <Button size="large" className="selected-pack" onClick={selectedPack}>
        Select Package <ReactSVG src="/icons/selectPack.svg" className="icon" />
      </Button>
    </div>
  );
};
export default PackageListDrop;
